/* eslint-env es6 */
import React, { useState, useEffect } from 'react';
import { useThemeStore, useAppStore, useSOWMessagesStore, useTabStore, useTranslation } from './store';
import OfflineIndicator from './components/OfflineIndicator';
import UpdateNotifier from './components/UpdateNotifier';
import NavBar from './components/NavBar';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import { DialogContainer } from './components/DialogContainer';
import { VeilContainer } from './components/VeilContainer';
import { queryParamsService } from './services/queryParams';
import './css/App.css';

function App() {
  const { currentTheme, initializeTheme } = useThemeStore();
  const { startPolling, setActiveTab } = useSOWMessagesStore();
  const { activeTab } = useTabStore();
  const { t } = useTranslation();
  queryParamsService.initialize();

  useEffect(() => {
    setActiveTab(activeTab);
  }, [activeTab]);
  
  useEffect(() => {
    setActiveTab(activeTab);
    startPolling();
    // Initialize theme
    initializeTheme();
  }, [initializeTheme]);
  
  useEffect(() => {
      const handleBeforeUnload = (event) => {
        let message = t('reloadMessage');
        event.returnValue = message; // Standard for most browsers
        return message; // For some older browsers
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      
      startPolling();

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
  }, []);

  return (
    <div className="app">
      <OfflineIndicator />
      <UpdateNotifier />
      <NavBar/>
      <main>
        <MainContent />
      </main>
      <Footer />
      {/* This single container renders all dialogs */}
      <DialogContainer />
      <VeilContainer />
    </div>
  );
}

export default App;